import {
  IN_ROOM_ANNOUNCEMENT_USER_JOINED,
  IN_ROOM_ANNOUNCEMENT_USER_LEFT,
  IN_ROOM_ANNOUNCEMENT_ICON_CLICKED,
} from "./types/inRoomAnnouncement";

export const inRoomAnnouncementUserJoined = (payload) => ({
  type: IN_ROOM_ANNOUNCEMENT_USER_JOINED,
  payload,
});

export const inRoomAnnouncementUserLeft = (payload) => ({
  type: IN_ROOM_ANNOUNCEMENT_USER_LEFT,
  payload,
});

export const inRoomAnnouncementIconClicked = (payload) => ({
  type: IN_ROOM_ANNOUNCEMENT_ICON_CLICKED,
  payload,
});
